import { mergeStyleSets } from '@uifabric/merge-styles'
import React from 'react'
import { format_time } from '../functions/format_time'
import { Score } from '../types/score'

const style = mergeStyleSets({
  main: {
    fontSize: 42,
    display: 'flex',
    alignItems: 'center',
    marginTop: 18,
    '>div': {
      marginLeft: 32,
    },
    'div:first-child': {
      marginLeft: 0,
    },
    '@media(max-width: 900px)': {
      fontSize: 24,
    }
  },
  title: {
    fontSize: 32,
    fontWeight: 'bold',
    marginBottom: 8
  },
  metric: {
    display: 'flex',
    'div': {
      marginRight: 18,
    },
    '.name': {
      fontSize: 18,
      fontWeight: 'bold',
    }
  },
})

export const ScoreView = ({name, score} : {name: String,score: Score}) => {
  return (
    <div className={style.main}>
      <div className={style.title}>{name}</div>
      <div className={style.metric}>
        <div>
          <div className="name">Time</div>
          <div className="value">{format_time(score.time)}</div>
        </div>
        <div>
          <div className="name">Mistakes</div>
          <div className="value">{score.mistakes}</div>
        </div>
      </div>
    </div>
  )
}